export default __webpack_public_path__ + "static/friendly-25e71c5290cbc06db0bf6ba03b1098d5.svg";